module.exports = __webpack_public_path__ + "media/images/logo-0fd35af51653aefa7681be0609beab13.png";